import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private errorMessageSubject = new BehaviorSubject<string | null>(null);

  showErrorMessage(message: string) {
    this.errorMessageSubject.next(message);
  }

  getErrorMessage(): Observable<string | null> {
    return this.errorMessageSubject.asObservable();
  }

  clearError() {
    this.errorMessageSubject.next(null);
  }
}
